import { useEffect, useRef } from "react"
import { pushGtmPageEvent } from "../gtm/interaction-event"
import { detectWebView } from "../utils/detectWebView"

interface PageViewEventOptions {
  customPageCategory?: string
  customPageSubCategory?: string
  numberOfSearchResults?: number
}

const usePageViewEvent = (
  locale: string,
  urlOriginal: string,
  menuData: any,
  title: string,
  options?: PageViewEventOptions
) => {
  const hasTracked = useRef(false)

  useEffect(() => {
    if (hasTracked.current || !window) {
      return
    }
    let host = ""
    if (window.location) {
      host = window.location.host
    }
    let pages = menuData?.pageInfo
    const isMobile = window.matchMedia("only screen and (max-width: 760px)").matches
    const searchPattern = new RegExp("^" + "qksa")
    const isQualificationStage = searchPattern.test(host)
    let validPath = pages?.parent && pages?.parentSlug && pages?.selected

    // Use custom page category/subcategory if provided, otherwise derive from menu data
    const pageCategory =
      options?.customPageCategory ??
      (validPath ? pages.parent : pages?.selected || window.location.pathname.split("/")[1])
    const pageSubCategory =
      options?.customPageSubCategory ??
      (validPath ? pages.parentSlug + "/" + pages.selected.split(" ").join("-").toLowerCase() + "/" : "")

    pushGtmPageEvent(
      "pageview",
      locale,
      urlOriginal,
      isMobile ? "mobile" : "desktop",
      isQualificationStage ? "qualifcation" : "production",
      title,
      window.location.hostname,
      null,
      pageCategory,
      pageSubCategory,
      options?.numberOfSearchResults,
      detectWebView()
    )
    hasTracked.current = true
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])
}

export default usePageViewEvent
